import script from "./AircraftsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AircraftsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AircraftsPage.vue?vue&type=style&index=0&id=0935a720&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0935a720"]])

export default __exports__